import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const GeofenceFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function GeofenceFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M21 16.35v-8.7c1.17-.57 1.99-1.75 1.99-3.14 0-1.93-1.57-3.5-3.49-3.5-1.39 0-2.58.82-3.14 1.99h-8.7a3.49 3.49 0 0 0-3.15-2c-1.93 0-3.5 1.57-3.5 3.5 0 1.39.82 2.59 2 3.15v8.7c-1.18.57-2 1.76-2 3.15 0 1.93 1.57 3.5 3.5 3.5 1.39 0 2.59-.82 3.15-2.01h8.69c.57 1.17 1.76 1.99 3.14 1.99 1.93 0 3.5-1.57 3.5-3.5 0-1.39-.82-2.58-2-3.15l.01.02Zm-15 .01v-8.7c.72-.35 1.3-.93 1.65-1.65h8.7c.35.72.93 1.31 1.65 1.65v8.69c-.73.35-1.31.93-1.66 1.66H7.65c-.35-.72-.93-1.31-1.66-1.65H6Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default GeofenceFilled;